module.exports = {
    DetectionsConsensus: "roboflow_core/detections_consensus@v1",
    ClipComparison: "roboflow_core/clip_comparison@v1",
    LMM: "roboflow_core/lmm@v1",
    LMMForClassification: "roboflow_core/lmm_for_classification@v1",
    OpenAI: "roboflow_core/open_ai@v1",
    OCRModel: "roboflow_core/ocr_model@v1",
    YoloWorldModel: "roboflow_core/yolo_world_model@v1",
    YoloWorld: "roboflow_core/yolo_world_model@v1",
    RoboflowInstanceSegmentationModel: "roboflow_core/roboflow_instance_segmentation_model@v1",
    InstanceSegmentationModel: "roboflow_core/roboflow_instance_segmentation_model@v1",
    RoboflowKeypointDetectionModel: "roboflow_core/roboflow_keypoint_detection_model@v1",
    KeypointsDetectionModel: "roboflow_core/roboflow_keypoint_detection_model@v1",
    RoboflowClassificationModel: "roboflow_core/roboflow_classification_model@v1",
    ClassificationModel: "roboflow_core/roboflow_classification_model@v1",
    RoboflowMultiLabelClassificationModel:
        "roboflow_core/roboflow_multi_label_classification_model@v1",
    MultiLabelClassificationModel: "roboflow_core/roboflow_multi_label_classification_model@v1",
    RoboflowObjectDetectionModel: "roboflow_core/roboflow_object_detection_model@v1",
    ObjectDetectionModel: "roboflow_core/roboflow_object_detection_model@v1",
    BarcodeDetector: "roboflow_core/barcode_detector@v1",
    BarcodeDetection: "roboflow_core/barcode_detector@v1",
    QRCodeDetector: "roboflow_core/qr_code_detector@v1",
    QRCodeDetection: "roboflow_core/qr_code_detector@v1",
    AbsoluteStaticCrop: "roboflow_core/absolute_static_crop@v1",
    DynamicCrop: "roboflow_core/dynamic_crop@v1",
    Crop: "roboflow_core/dynamic_crop@v1",
    DetectionsFilter: "roboflow_core/detections_filter@v1",
    DetectionOffset: "roboflow_core/detection_offset@v1",
    RelativeStaticCrop: "roboflow_core/relative_statoic_crop@v1",
    DetectionsTransformation: "roboflow_core/detections_transformation@v1",
    RoboflowDatasetUpload: "roboflow_core/roboflow_dataset_upload@v1",
    ContinueIf: "roboflow_core/continue_if@v1",
    PerspectiveCorrection: "roboflow_core/perspective_correction@v1",
    DynamicZone: "roboflow_core/dynamic_zone@v1",
    DetectionsClassesReplacement: "roboflow_core/detections_classes_replacement@v1",
    Expression: "roboflow_core/expression@v1",
    PropertyDefinition: "roboflow_core/property_definition@v1",
    PropertyExtraction: "roboflow_core/property_definition@v1",
    DimensionCollapse: "roboflow_core/dimension_collapse@v1",
    FirstNonEmptyOrDefault: "roboflow_core/first_non_empty_or_default@v1",
    BackgroundColorVisualization: "roboflow_core/background_color_visualization@v1",
    BlurVisualization: "roboflow_core/blur_visualization@v1",
    BoundingBoxVisualization: "roboflow_core/bounding_box_visualization@v1",
    CircleVisualization: "roboflow_core/circle_visualization@v1",
    ColorVisualization: "roboflow_core/color_visualization@v1",
    CornerVisualization: "roboflow_core/corner_visualization@v1",
    CropVisualization: "roboflow_core/crop_visualization@v1",
    DotVisualization: "roboflow_core/dot_visualization@v1",
    EllipseVisualization: "roboflow_core/ellipse_visualization@v1",
    HaloVisualization: "roboflow_core/halo_visualization@v1",
    LabelVisualization: "roboflow_core/label_visualization@v1",
    MaskVisualization: "roboflow_core/mask_visualization@v1",
    PixelateVisualization: "roboflow_core/pixelate_visualization@v1",
    PolygonVisualization: "roboflow_core/polygon_visualization@v1",
    TriangleVisualization: "roboflow_core/triangle_visualization@v1",
    RoboflowCustomMetadata: "roboflow_core/roboflow_custom_metadata@v1"
};
